import React, { useEffect, useState } from "react";
import "./Quiz.css";
import SideBar from "../Dashboard/StudentDashboard/Sidebar/SideBar";
import ProfileBar from "../Dashboard/StudentDashboard/Profilebar/ProfileBar";
import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Box,
    Button,
    Divider,
    Grid2,
    List,
    ListItem,
    ListItemText,
    Stack,
    Step,
    StepConnector,
    stepConnectorClasses,
    StepLabel,
    Stepper,
    styled,
    Typography,
} from "@mui/material";
import one from "./1.png";
import two from "./2.png";
import three from "./3.png";
import four from "./4.png";
import five from "./5.png";
import attemptedQuiz from "./attemptedQuiz.png";
import left from "./left.png";
import earnedPoints from "./earnedPoints.png";
import fadedBG from "./fadedBG.svg";
import guidelinesImg from "./guidelines.png";
import pen from "./pen.svg";
import success from "./success.png";
import quizImg from "./quizImg.png";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {
    useGetQuizResponseListMutation,
    useGetQuizQuestionByQuizIdListMutation,
} from "../../apiSlice";
import { useLocation, useNavigate } from "react-router-dom";
import Breadcrumb from "../StudentBreadcrumb/Breadcrumb";
import { QrCodeOutlined } from "@mui/icons-material";

const QuizDetails = () => {
    const navigate = useNavigate();

    const [quizResponseListData, setQuizResponseListData] = useState([]);
    const [quizQuestionsById, setQuizQuestionsById] = useState([]);

    const [studentQuizResponseListAPI] = useGetQuizResponseListMutation();
    const [studentQuizQuestionsByIdAPI] =
        useGetQuizQuestionByQuizIdListMutation();

    const ImageStepIcon = ({ active, completed, icon }) => {
        const stepIcons = {
            1: one,
            2: two,
            3: three,
            4: four,
            5: five,
        };

        return (
            <div
                style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                }}
            >
                <img
                    src={stepIcons[icon]}
                    alt={`Step ${icon}`}
                    style={{ width: 38, height: 38 }}
                />
            </div>
        );
    };

    const quizProgressObj = [
        { icon: one },
        { icon: two },
        { icon: three },
        { icon: four },
        { icon: five },
    ];

    const CustomConnector = styled(StepConnector)(({ theme }) => ({
        [`&.${stepConnectorClasses.alternativeLabel}`]: {
            top: 17, // Half of icon height (48/2) to center vertically
        },
        [`&.${stepConnectorClasses.active}`]: {
            [`& .${stepConnectorClasses.line}`]: {
                borderColor: theme.palette.secondary.main,
            },
        },
        [`&.${stepConnectorClasses.completed}`]: {
            [`& .${stepConnectorClasses.line}`]: {
                borderColor: theme.palette.secondary.main,
            },
        },
        [`& .${stepConnectorClasses.line}`]: {
            borderColor: "#eaeaf0",
            borderTopWidth: 2,
            borderRadius: 2,
            maxWidth: "85%",
            margin: "auto",
        },
    }));

    const steps = [1, 2, 3, 4, 5];

    const [activeStep, setActiveStep] = useState(0);

    const guidelines = [
        "1. Select only one answer per question.",
        "2. Retry the quiz set if you don't succeed.",
        "3. The second attempt has different questions.",
        "4. Correct answers will be shown at the end.",
        "5. Passed sets can't be retaken.",
    ];
    const [dense, setDense] = useState(false);
    // const [loading, setLoading] = useState(true);
    // const [quizMaster] = useGetQuizMasterMutation();
    // const [quizMasterData, setQuizMasterData] = useState([]);

    // useEffect(()=>{
    //   console.log('hello', loading);
    //   if(loading){
    //     quizMaster().then((data)=>setQuizMasterData(data));
    //     // if(quizMaster){
    //     //   setQuizMasterData(quizMaster);
    //     //   setLoading(false);
    //     // }
    //   }
    // },[loading]);

    /**
     * Function for Fetching Question By Id Data from
     * EndPoint "quiz/QuizQuestionByQuizIdList?quizId=${quizId}"
     */
    const fetchQuestionsById = async (quizId) => {
        try {
            const questionByIdData = await studentQuizQuestionsByIdAPI(quizId);
            setQuizQuestionsById(questionByIdData);
        } catch (error) {
            console.log(error);
        }
    };

    /**
     * Fucntion for handling the `Take Quiz` Button onClick Functionality
     */
    const handleTakeQuiz = (quizId) => {
        console.log(quizId);

        /**
         * For testing only
         */
        fetchQuestionsById(quizId);

        /**
         * setting cookie for quizId
         */
        localStorage.setItem("quizId", quizId);
        navigate("/StudentDashboard/Quiz/QuizContent");
    };

    useEffect(() => {
        const fetchData = async () => {
            try {
                /**
                 * Quiz Response List
                 */
                const quizResponseList = await studentQuizResponseListAPI();
                setQuizResponseListData(quizResponseList.data);
            } catch (error) {
                console.log(error);
            }
        };

        fetchData();
    }, []);

    /**
     * Count quiz that are `Attempted`
     */
    const attemptedQuizStat = quizResponseListData.reduce((count, quiz) => {
        return quiz.isAttempted === true ? count + 1 : count;
    }, 0);

    /**
     * Count quiz that are `Remaining to Attempt`
     */
    const leftQuizStat = quizResponseListData.length - attemptedQuizStat;

    /**
     * Count quiz that are `Successfully Passed`
     */
    const successQuizStat = quizResponseListData.reduce((count, quiz) => {
        return quiz.quizPercentage >= 70 ? count + 1 : count;
    }, 0);

    /**
     * FOR TESTING PURPOSE ONLY
     */
    // const successQuizStat = 7;

    /**
     * Calculating Quiz Earned Points
     */
    const quizEarnedPoints = successQuizStat * 10;

    /**
     * Total Quiz
     */
    const totalQuiz = quizResponseListData.length;

    /**
     * FOR TESTING PURPOSE ONLY
     */
    // const totalQuiz = 10;

    console.log("successQuizStat/totalQuiz * 100 ==== ", successQuizStat/totalQuiz * 100)


    /**
     * Setting the state according to the `successQuizStat`
     */
    useEffect(() => {
        successQuizStat >= 0 && successQuizStat < 4
            ? setActiveStep(0)
            : successQuizStat >= 4 && successQuizStat < 6
            ? setActiveStep(1)
            : successQuizStat >= 6 && successQuizStat < 8
            ? setActiveStep(2)
            : successQuizStat >= 8 && successQuizStat < 10
            ? setActiveStep(3)
            : setActiveStep(4);
    }, [successQuizStat]);

    /**
     * Logging the Quiz Response List
     */
    useEffect(() => {
        console.log("quizResponseListData", quizResponseListData);
    }, [quizResponseListData]);

    /**
     * Logging the Quiz Question List By id
     */
    useEffect(() => {
        console.log("Question By ID::::::", quizQuestionsById);
    }, [quizQuestionsById]);

    return (
        <>
            <SideBar />
            <Box
                sx={{
                    flexGrow: 1,
                    position: "relative",
                    width: "calc(100vw - 60px)",
                    padding: "20px",
                    height: "100vh",
                    overflowY: "scroll",
                    left: "60px",
                    backgroundColor: "#F8F9FD",
                }}
            >
                <Breadcrumb />
                <Grid2>
                    <Box bgcolor="white" padding="20px" borderRadius="12px">
                        {/* my iteration */}
                        <Stack>
                            <Typography variant="h5" color="black">
                                Progress
                            </Typography>
                            <Box
                                sx={{
                                    padding: "10px 0",
                                    width: "100%",
                                }}
                            >
                                <Box
                                    sx={{
                                        width: "100%",
                                        display: "grid",
                                        gridTemplateColumns: "repeat(5, 1fr)",
                                        // columnGap: 1,
                                        position: "relative",
                                        "&:before": {
                                            content: '""',
                                            position: "absolute",
                                            width: "80%",
                                            bgcolor: "#F8F8F8",
                                            // bgcolor: "#F85006",
                                            height: "5px",
                                            left: "10%",
                                            top: "50%",
                                            translate: "0 -50%",
                                        },
                                        "&:after": {
                                            content: '""',
                                            position: "absolute",
                                            // width: "100%",
                                            width: `${
                                                ((successQuizStat / totalQuiz) *
                                                    100 *
                                                    80) /
                                                100
                                            }%`,
                                            bgcolor: "#F85006",
                                            height: "5px",
                                            left: "10%",
                                            top: "50%",
                                            translate: "0 -50%",
                                            // boxShadow: "0 0 10px #F85006",
                                            boxShadow: "0 0 10px #F85006, 0 0 20px #F85006"
                                        },
                                    }}
                                >
                                    {quizProgressObj.map((item, idx) => (
                                        <Box
                                            key={idx}
                                            sx={{
                                                position: "relative",
                                                zIndex: 10,
                                                display: "flex",
                                                flexDirection: "column",
                                                justifyContent: "center",
                                                alignItems: "center",
                                            }}
                                        >
                                            {/* Background Image Blur */}
                                            <img
                                                src={item.icon}
                                                style={{
                                                    width: "25%",
                                                    aspectRatio: "1/1",
                                                    height: "auto",
                                                    filter: "blur(15px)",
                                                    // opacity: "10%"
                                                }}
                                            />
                                            {/* Front Image */}
                                            <img
                                                src={item.icon}
                                                style={{
                                                    width: "25%",
                                                    aspectRatio: "1/1",
                                                    height: "auto",
                                                    position: "absolute",
                                                    // opacity: "10%"
                                                }}
                                            />
                                        </Box>
                                    ))}
                                </Box>
                            </Box>
                        </Stack>
                    </Box>
                    <Box
                        marginTop="20px"
                        bgcolor="white"
                        padding="20px"
                        borderRadius="12px"
                        position="relative"
                    >
                        <Box position="absolute" bottom="0" left="-20px">
                            {/* <img src={fadedBG} style={{ height: 'auto', width: '300px', opacity: '0.2' }} /> */}
                        </Box>
                        <Stack direction="row" justifyContent="space-between">
                            <Stack>
                                <img
                                    src={attemptedQuiz}
                                    style={{ height: "100px", width: "175px" }}
                                />
                                <Box
                                    sx={{
                                        display: "flex",
                                        justifyContent: "center",
                                        alignContent: "center",
                                        gap: "10px",
                                    }}
                                >
                                    <Typography>Attempted Quiz</Typography>
                                    <Typography
                                        color="secondary"
                                        fontWeight={700}
                                    >
                                        {attemptedQuizStat}
                                    </Typography>
                                </Box>
                            </Stack>
                            <Stack>
                                <img
                                    src={left}
                                    style={{ height: "100px", width: "175px" }}
                                />
                                <Box
                                    sx={{
                                        display: "flex",
                                        justifyContent: "center",
                                        alignContent: "center",
                                        gap: "10px",
                                    }}
                                >
                                    <Typography>Quiz Left</Typography>
                                    <Typography
                                        color="secondary"
                                        fontWeight={700}
                                    >
                                        {leftQuizStat}
                                    </Typography>
                                </Box>
                            </Stack>
                            <Stack>
                                <img
                                    src={success}
                                    style={{ height: "100px", width: "175px" }}
                                />
                                <Box
                                    sx={{
                                        display: "flex",
                                        justifyContent: "center",
                                        alignContent: "center",
                                        gap: "10px",
                                    }}
                                >
                                    <Typography>Success</Typography>
                                    <Typography
                                        color="secondary"
                                        fontWeight={700}
                                    >
                                        {successQuizStat}
                                    </Typography>
                                </Box>
                            </Stack>
                            <Stack>
                                <img
                                    src={earnedPoints}
                                    style={{ height: "100px", width: "175px" }}
                                />
                                <Box
                                    sx={{
                                        display: "flex",
                                        justifyContent: "center",
                                        alignContent: "center",
                                        gap: "10px",
                                    }}
                                >
                                    <Typography>Earned Points</Typography>
                                    <Typography
                                        color="secondary"
                                        fontWeight={700}
                                    >
                                        {quizEarnedPoints}
                                    </Typography>
                                </Box>
                            </Stack>
                        </Stack>
                    </Box>
                    <Box marginTop="20px" bgcolor="white" borderRadius="12px">
                        <Accordion
                            defaultExpanded
                            sx={{
                                background: "transparent",
                                boxShadow: "none",
                            }}
                        >
                            <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel-content"
                                id="panel-header"
                            >
                                <Typography variant="h5">Guidelines</Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                <Stack
                                    direction="row"
                                    justifyContent="space-between"
                                >
                                    <Box>
                                        <img
                                            src={guidelinesImg}
                                            style={{
                                                height: "220px",
                                                width: "auto",
                                            }}
                                        />
                                    </Box>
                                    <List dense={dense}>
                                        {guidelines.map((guideline, index) => (
                                            <ListItem
                                                key={index}
                                                disablePadding
                                            >
                                                <ListItemText
                                                    primary={guideline}
                                                />
                                            </ListItem>
                                        ))}
                                    </List>
                                    <Box position="relative">
                                        <img
                                            src={pen}
                                            style={{
                                                height: "50px",
                                                width: "auto",
                                                position: "absolute",
                                                bottom: "5px",
                                                right: "5px",
                                            }}
                                        />
                                    </Box>
                                </Stack>
                            </AccordionDetails>
                        </Accordion>
                    </Box>
                    <Box
                        marginTop="20px"
                        bgcolor="white"
                        borderRadius="12px"
                        padding="20px"
                    >
                        <Typography variant="h5" marginBottom="10px">
                            Quiz
                        </Typography>
                        <Divider />
                        <Stack spacing={2} marginTop="20px">
                            {Object.keys(quizResponseListData).length === 0 ? (
                                <Typography
                                    variant="subtitle1"
                                    color="secondary"
                                >
                                    No Quiz Data Available
                                </Typography>
                            ) : (
                                quizResponseListData?.length > 0 &&
                                quizResponseListData.map((quiz, index) => (
                                    <Stack
                                        direction="row"
                                        border="1px solid #F3F0EC"
                                        padding="10px"
                                        borderRadius="6px"
                                        justifyContent="space-between"
                                        alignItems="center"
                                        key={index}
                                    >
                                        <Stack direction="row" spacing={2}>
                                            <Box>
                                                <img
                                                    src={quizImg}
                                                    style={{
                                                        height: "50px",
                                                        width: "60px",
                                                    }}
                                                />
                                            </Box>
                                            <Box>
                                                <Typography>
                                                    {quiz.quizTitle}
                                                </Typography>
                                                <Typography>
                                                    {quiz.quizDescription}
                                                </Typography>
                                            </Box>
                                        </Stack>
                                        <Box>
                                            <Button
                                                variant="contained"
                                                color="secondary"
                                                disabled={
                                                    quiz.quizPercentage >= 70
                                                        ? true
                                                        : quiz.attemptCount < 2
                                                        ? false
                                                        : true
                                                }
                                                onClick={() =>
                                                    handleTakeQuiz(quiz.quizId)
                                                }
                                            >
                                                Take Quiz
                                            </Button>
                                        </Box>
                                    </Stack>
                                ))
                            )}
                        </Stack>
                    </Box>
                </Grid2>
            </Box>
        </>
    );
};

export default QuizDetails;
